import { createSlice } from '@reduxjs/toolkit';
import { LOCALES } from '../../../lang';
import messages from '../../../lang/messages';

const initialState = {
	lang: LOCALES.en,
	messages: messages || [],
};

export const localizationSlice = createSlice({
	name: 'localization',
	initialState,
	reducers: {
		resetState: () => initialState,
		setLanguage: (state, action) => {
			const { payload: lang = LOCALES.en } = action;
			state.lang = lang;
		},
		addMessages: (state, action) => {
			const { payload: messages } = action;
			Object.keys(messages).forEach(lang => {
				if (state?.messages?.[lang]) {
					state.messages[lang] = { ...messages[lang], ...state.messages[lang] };
				}
			});
		},
	},
});
